import React, { lazy } from "react";
import { Route } from "react-router-dom";

const RouteWrapper = lazy(() => import("./routeWrapper"));

const Passbook = lazy(() => import("../pages/passbook"));
const OrgAccount = lazy(() => import("../pages/orgAccount"));
const CurrencyRate = lazy(() => import("../pages/CurrencyRates/currencyRatesUI"));
const PoolAccount = lazy(() => import("../pages/loadPoolAccountPages/loadPoolAccount"));

const RecurringTransfer = lazy(() => import("../components/loadaccount/recurringTransfers"));
const SettlementsEmployee = lazy(() => import("../components/wallet/employeesettlements"));
const Settlements = lazy(() => import("../components/wallet/settlements"));
const SettlementTabs = lazy(() => import("../components/wallet/settlementTabs"));
const WalletControl = lazy(() => import("../components/wallet/walletcontrol"));
const BudgetHome = lazy(() => import("../components/budget/budgetHome"));
const AllTransfer = lazy(() => import("../components/loadaccount/loadhistory"));
const AssignCard = lazy(() => import("../components/wallet/orgreconsilation"));
const BankTransferEmp = lazy(() => import("../components/wallet/banktransfer-employee"));

const FinanceRoutes = [
    <Route exact path="/passbook" component={Passbook} />,
    <Route exact path="/walletcontrol" component={WalletControl} />,
    <Route exact path={["/settlements", "/currency", "/invoice"]} component={Settlements} />,
    <Route exact path="/poolAccount" component={PoolAccount} />,
    <Route exact path="/orgAccount" component={OrgAccount} />,
    <Route exact path="/budget" component={BudgetHome} />,

    <RouteWrapper
        exact
        path={["/banktransfer", "/recurringtransfer"]}
        layout={BankTransferEmp}
        routes={[
            <Route exact path="/banktransfer" component={AllTransfer} />,
            <Route exact path="/recurringtransfer" component={RecurringTransfer} />
        ]}
    />,

    <RouteWrapper
        exact
        path={["/settlementTabs/*", "/settlementEmployeeTabs/settlements"]}
        layout={SettlementTabs}
        routes={[
            <Route exact path="/settlementTabs/settlements" component={Settlements} />,
            <Route
                exact
                path="/settlementEmployeeTabs/settlements"
                component={SettlementsEmployee}
            />,
            <Route exact path="/settlementTabs/orgreconsilation" component={AssignCard} />
        ]}
    />,

    <Route exact path={["/currencyrates", "/currencyrates/:component"]} component={CurrencyRate} />
];

export default FinanceRoutes;
